var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "searchBar", attrs: { id: "search-bar" } },
    [
      _c(
        "div",
        {
          staticClass: "input",
          class: { active: _vm.resultActive },
          on: {
            click: function () {
              return _vm.toggleSearch(true)
            },
          },
        },
        [
          _c("div", { staticClass: "material-icons search-icon" }, [
            _vm._v("search"),
          ]),
          _vm._v(" "),
          _vm.selectedSearch
            ? _c("KeyboardShortcut", [
                _vm._v(_vm._s(_vm.$t("search.prefix." + _vm.selectedSearch))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.resultActive,
                  expression: "!resultActive",
                },
              ],
              staticClass: "typer-wrapper",
              attrs: { id: "typeWriter" },
              on: {
                click: function () {
                  return _vm.toggleSearch(true)
                },
              },
            },
            [
              !_vm.isTherePrefix
                ? _c("vue-typer", {
                    attrs: {
                      text: _vm.$_.shuffle(_vm.getTyperSentences),
                      repeat: Infinity,
                      shuffle: false,
                      "initial-action": "erasing",
                      "pre-type-delay": 70,
                      "type-delay": 70,
                      "pre-erase-delay": 2000,
                      "erase-delay": 250,
                      "erase-style": "select-all",
                      "erase-on-complete": false,
                      "caret-animation": "blink",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText",
              },
            ],
            ref: "searchInput",
            attrs: { id: "search-bar-input", autocomplete: "off" },
            domProps: { value: _vm.searchText },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchText = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "keyboard-shortcut" },
            [
              !_vm.isAnyPrefixTyped
                ? _c("KeyboardShortcut", [
                    _vm._v(_vm._s(_vm.isMacOS ? "⌘" : "CTRL +") + " K"),
                  ])
                : _c("KeyboardShortcut", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("search.tapTo", {
                            prefix: _vm.capitalizeFirstLetter(_vm.searchText),
                          })
                        ) +
                        "\n            "
                    ),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.resultActive,
              expression: "resultActive",
            },
          ],
          staticClass: "result-search",
          class: { active: _vm.resultActive },
        },
        [
          _vm.searchText.length <= 0
            ? _c("div", { staticClass: "empty" }, [
                _c("div", { staticClass: "material-icons search-icon" }, [
                  _vm._v("search"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-title" }, [
                  _vm._v(_vm._s(_vm.$t("search.searchAreaTitle"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-description" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc1")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.jump"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.new"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.message"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.chatbot"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.table"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.module"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.dm"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc2")) +
                        "\n                "
                    ),
                    _c("KeyboardShortcut", [
                      _vm._v(_vm._s(_vm.$t("search.prefix.visitor"))),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("search.searchAreaDesc3")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
              ])
            : _vm.results.length > 0
            ? _c(
                "div",
                { staticClass: "items" },
                _vm._l(_vm.results, function (item, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "item",
                      class: [
                        {
                          active: index === _vm.navigationIndex,
                          "centered-name":
                            !item.keywords || item.keywords.length === 0,
                        },
                      ],
                      attrs: { id: "item-" + index },
                      on: {
                        click: function ($event) {
                          return _vm.action(item)
                        },
                      },
                    },
                    [
                      _c("KeyboardShortcut", [
                        _vm._v(_vm._s(_vm.$t("search.prefix." + item.prefix))),
                      ]),
                      _vm._v(" "),
                      item.prefix === "visitor"
                        ? _c(
                            "div",
                            {
                              staticClass: "content",
                              class: { visitor: item.prefix === "visitor" },
                            },
                            [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(_vm._s(_vm.getName(item.name))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "visitor-details" }, [
                                _c(
                                  "div",
                                  { staticClass: "visitor-details-item" },
                                  [
                                    _c("PlatformIcon", {
                                      attrs: {
                                        platform: item.payload.platformIcon,
                                        size: 18,
                                      },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(item.payload.channelName) +
                                        "\n                        "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "visitor-details-item" },
                                  [
                                    _c("AgentAvatar", {
                                      attrs: {
                                        userID: item.payload.ownerId,
                                        size: 18,
                                      },
                                    }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(item.payload.ownerName) +
                                        "\n                        "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        : _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.getName(item.name))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "keywords" },
                              [
                                _vm._l(
                                  (item.keywords || []).slice(0, 2),
                                  function (keyword) {
                                    return _c(
                                      "div",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(keyword) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  (item.keywords || []).slice(2, 6),
                                  function (keyword) {
                                    return _c("div", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(keyword) +
                                          "\n                        "
                                      ),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "empty" }, [
                _vm.selectedSearch === "message"
                  ? _c("div", { staticClass: "material-icons search-icon" }, [
                      _vm._v("search"),
                    ])
                  : _c("div", { staticClass: "material-icons search-icon" }, [
                      _vm._v("sentiment_dissatisfied"),
                    ]),
                _vm._v(" "),
                _vm.selectedSearch === "message"
                  ? _c(
                      "div",
                      { staticClass: "message-search-info" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.searchText) +
                            " ifadesini mesajlarda aramak için\n                "
                        ),
                        _c("KeyboardShortcut", [_vm._v("ENTER")]),
                        _vm._v(
                          "\n                tuşuna\n                basınız\n            "
                        ),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "info-title" }, [
                      _vm._v("Not Found Anything"),
                    ]),
              ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "result-bottom" },
            [
              _c("KeyboardShortcut", [
                _c("div", { staticClass: "material-icons keyboard-icon" }, [
                  _vm._v("keyboard_arrow_up"),
                ]),
              ]),
              _vm._v(" "),
              _c("KeyboardShortcut", [
                _c("div", { staticClass: "material-icons keyboard-icon" }, [
                  _vm._v("keyboard_arrow_down"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("search.navigateBtn"))),
              ]),
              _vm._v(" "),
              _c("KeyboardShortcut", [
                _c("div", { staticClass: "material-icons keyboard-icon" }, [
                  _vm._v("keyboard_return"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("search.selectBtn"))),
              ]),
              _vm._v(" "),
              _c("KeyboardShortcut", [_vm._v("ESC")]),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("search.cancelBtn"))),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.openRespresentativeOptions
        ? _c(
            "a-modal",
            {
              staticClass: "representativeSettings",
              staticStyle: { top: "20px" },
              attrs: {
                destroyOnClose: true,
                footer: null,
                title: _vm.$t("message.represantativeSettings"),
                visible: true,
                width: 700,
              },
              on: {
                cancel: function () {
                  return (_vm.openRespresentativeOptions = false)
                },
              },
            },
            [
              _c("RepresentativeSettings", {
                attrs: {
                  "is-target-notification": _vm.openRespresentativeOptions,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "message-search-modal-index",
          staticStyle: { "z-index": "1000" },
          attrs: {
            title: "Message Search",
            footer: null,
            width: 800,
            visible: _vm.messageSearchOpen,
          },
          on: {
            ok: function () {
              return (_vm.messageSearchOpen = false)
            },
            cancel: _vm.closeMessageSearchModalViaButton,
          },
        },
        [
          _c("MessageSearch", {
            attrs: { "default-query": _vm.messageSearchQuery },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }